export const convos = [
  {
    channel: "Phone call · 9:42 PM",
    lines: [
      ["ai", "Thanks for calling Serenity Spa, this is Ava. How can I help you tonight?"],
      ["customer", "Hi, do you have anything open for a massage this Saturday?"],
      ["ai", "I'd love to help. I have 10:00 AM or 2:30 PM for a 60-minute massage. Which works better?"],
      ["customer", "2:30, please."],
      ["ai", "Perfect, you're booked for Saturday at 2:30 PM. I just texted you a confirmation. Anything else?"],
      ["system", "Appointment added to calendar · Confirmation text sent"],
    ],
  },
  {
    channel: "Email + text follow-up",
    lines: [
      ["ai", "Hi Mark, I saw your company just took on two new commercial builds. Congrats! We help contractors cut admin time by about 10 hours a week. Worth a quick chat?"],
      ["system", "No reply after 3 days · Friendly follow-up sent"],
      ["ai", "Just bumping this up, Mark. Happy to share a 2-minute example from a contractor like you."],
      ["customer", "Sure, send it over. Could we talk next week?"],
      ["ai", "Great! Here's the example. Does Tuesday at 10 AM or Wednesday at 3 PM work?"],
      ["customer", "Tuesday at 10."],
      ["system", "Meeting booked · Lead marked as hot · Sales team notified"],
    ],
  },
  {
    channel: "Google review reply",
    lines: [
      ["customer", "★★★★☆ Great work on our lawn, but the crew showed up an hour late."],
      ["ai", "Thanks so much, Jen! We're thrilled you love the lawn, and we're sorry about the delay. We've shared this with the crew lead, and your next visit has a priority time slot. 🌿"],
      ["system", "Reply posted in 4 minutes · Owner notified about late arrival"],
    ],
  },
  {
    channel: "Weekly content plan",
    lines: [
      ["system", "Monday · Generating this week's posts for Bloom Med Spa"],
      ["ai", "Post 1 (Instagram): \"Glow season is here ✨ Book a hydrafacial this week and get a free LED add-on.\""],
      ["ai", "Post 2 (Facebook): A behind-the-scenes look at our new treatment room, with a carousel of 4 photos."],
      ["ai", "Post 3 (Instagram Reel): A 15-second \"3 skincare myths\" video with captions."],
      ["customer", "Love these. Approve all."],
      ["system", "3 posts scheduled · Best posting times selected automatically"],
    ],
  },
  {
    channel: "Client check-in · text",
    lines: [
      ["ai", "Hi Sara, welcome to Bright Smiles Dental! Here's your new-patient form and parking info for Thursday."],
      ["customer", "Thanks! Do you take Delta Dental?"],
      ["ai", "We do! Just bring your card, and we'll handle the rest."],
      ["system", "2 days after visit"],
      ["ai", "Hi Sara, how are you feeling after your cleaning? Reply 1–5 to let us know how we did."],
      ["customer", "5! Super friendly team."],
      ["system", "Review link sent · Patient flagged as a promoter"],
    ],
  },
  {
    channel: "Applicant screening",
    lines: [
      ["system", "42 new applications for Landscape Crew Lead"],
      ["ai", "Top 5 matches found. All have 3+ years of crew leadership and a valid driver's license."],
      ["customer", "Is the position full-time? What's the pay?"],
      ["ai", "Yes, it's full-time at $24–28/hr plus overtime. Would you like to book a quick interview?"],
      ["customer", "Yes please!"],
      ["system", "Interview booked for Wednesday at 9 AM · Hiring manager notified"],
    ],
  },
  {
    channel: "Sales call summary",
    lines: [
      ["system", "Call with Riverside Realty ended · 28 min"],
      ["ai", "Summary: They want to cut response time to new leads. Their budget is approved for Q3."],
      ["ai", "Concerns: integration with their current CRM and training for 12 agents."],
      ["ai", "Next steps: send a CRM integration overview by Friday and schedule a demo with their team lead."],
      ["system", "Notes saved to CRM · Follow-up task created for Friday"],
    ],
  },
  {
    channel: "Website build",
    lines: [
      ["customer", "We're a family roofing company. We need a site that gets more estimate requests."],
      ["ai", "Got it! Here's your plan: a homepage with trust badges, a service-area map, before-and-after photos, and a 30-second estimate form."],
      ["system", "Draft site ready · Mobile and desktop checked"],
      ["ai", "Your new site is live. The estimate form connects to your calendar and your AI Receptionist."],
      ["system", "First week: 14 estimate requests (up from 4)"],
    ],
  },
  {
    channel: "Monthly finance report",
    lines: [
      ["system", "Report ready · September"],
      ["ai", "Revenue was $86,400, up 12% from August. Your top service was kitchen remodels."],
      ["ai", "Heads up: 3 invoices totaling $7,250 are over 30 days late. Reminders have been sent."],
      ["ai", "Material costs rose 8%. You may want to review supplier pricing."],
      ["customer", "Thanks, can you send this to my accountant?"],
      ["system", "Report emailed to accountant · Next report scheduled for Oct 1"],
    ],
  },
];

const shot = (key, alt, extra) => ({ desktop: `/demos/duaura-demo-${key}-desktop.png`, phone: `/demos/duaura-demo-${key}-phone.png`, alt, ...extra });

export const imageDemos = {
  "AI Social Media": shot("social", "Sample weekly social media plan with 3 scheduled posts"),
  "AI Hiring Assistant": shot("hiring", "Sample hiring flow: short application, shortlist of 5 from 42 applicants, interview booked"),
  "AI Finance Reports": shot("finance", "Sample monthly finance report in plain English"),
  "AI Sales Call Notes": shot("callnotes", "Sample sales call summary with concerns and next steps"),
  "AI Response": shot("response", "Sample AI replies to a Google review and a customer email", {
    cta: { label: "Try our AI on Facebook Messenger", href: "https://m.me/1004052352799773" },
  }),
  "AI Website Builder": shot("website", "A landing page Duaura built for roofing companies, on laptop and phone"),
};
